// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabsStatic_tabContainer__PaNwa","tabActive":"tabsStatic_tabActive__RBpLg"};